import { LocationCreateSchema } from '@repo/schemas/location/locationCreate';
import { LocationEditSchema } from '@repo/schemas/location/locationEdit';
import { useFormContext } from 'react-hook-form';

import LocationFormFieldset from '@/components/features/manage/manage-locations/LocationFormFieldset';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';

export default function LocationFormFields() {
  const form = useFormContext<LocationEditSchema | LocationCreateSchema>();

  return (
    <>
      <FormField
        name={'name'}
        control={form.control}
        render={({ field }) => (
          <FormItem className={'col-span-1'}>
            <FormLabel>Nazwa</FormLabel>
            <FormControl>
              <Input {...field} value={field.value ?? ''} placeholder={'Nazwa lokacji'} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <LocationFormFieldset form={form} coordinatesName={'coordinates'} addressName={'address'} />
      <FormField
        name={'desc'}
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              Opis <small className={'text-text-tertiary text-sm'}>(opcionalne)</small>
            </FormLabel>
            <FormControl>
              <Textarea
                placeholder={'Opis'}
                {...field}
                value={field.value ?? ''}
                onChange={(event) => {
                  const value = event.target.value;
                  field.onChange(value ? value : null);
                }}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
